module.exports = __webpack_public_path__ + "static/media/hakutsuruginjo.2d3dfc20.png";